<template>
  <div>
    <app-cells>
      <h1 class="title">Transfer Schedule</h1>
      <app-date-picker
        @change="onDateChange"
        v-model="date"
        placeholder="Specify a date"
        class="datepicker--220"
        :clearable="false"
      />
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view :schedule_own="schedule_own" :schedule_rental="schedule_rental" :schedule_taxi="schedule_taxi" />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { getOwnCarsSchedule, getRentalCarsSchedule, getTaxiSchedule } from '@/http'
import { format } from 'date-fns'

export default {
  name: 'TransferScheduleLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'transfer-schedule-own', label: 'Own cars' },
        { name: 'transfer-schedule-rental', label: 'Rental cars' },
        { name: 'transfer-schedule-taxi', label: 'Taxi drivers' },
      ],
      schedule_own: null,
      schedule_rental: null,
      schedule_taxi: null,
      date: format(new Date(), 'yyyy-MM-dd'),
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onDateChange() {
      this.fetchItems()
    },
    fetchItems() {
      Promise.all([
        getOwnCarsSchedule(this.date),
        getRentalCarsSchedule(this.date),
        getTaxiSchedule(this.date),
      ])
        .then(res => {
          this.schedule_own = res[0].data
          this.schedule_rental = res[1].data
          this.schedule_taxi = res[2].data
          this.is_loaded = true
        })
    }
  }
}
</script>
